import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/home/HomeView.vue'
import {AppConfig} from "@/config";

const routes: Array<RouteRecordRaw> = [
  {
    path: AppConfig.route_home,
    name: 'home',
    component: HomeView
  },
  {
    path: AppConfig.route_about,
    name: 'about',
    component: () => import('../views/about/AboutUs.vue')
  },
  {
    path: AppConfig.route_cpCredit,
    name: 'cpCredit',
    component: () => import('../views/cpcredit/CpCredit.vue')
  },
  {
    path: AppConfig.route_cpPromotion,
    name: 'cpPromotion',
    component: () => import('../views/cppromotion/CpPromotion.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(){
    return{
      left:0,
      top:0
    }
  }
})

export default router
